<div class="row">
    <nb-accordion class="col-md-12">
        <nb-accordion-item *ngFor="let corso of corsi">
            <nb-accordion-item-header>
                {{corso.course.fullname}}
            </nb-accordion-item-header>
            <nb-accordion-item-body>
                <span *ngIf="corso.groups?.length">Gruppi associati al corso</span>
                <nb-list class="container">
                    <nb-list-item
                        *ngFor="let gruppo of corso.groups"
                        [class.groupHighlight]="gruppo.idnumber"
                    >
                        {{gruppo.name}}
                    </nb-list-item>
                    <nb-list-item *ngIf="!corso.groups?.length">
                        nessun gruppo
                    </nb-list-item>
                </nb-list>
            </nb-accordion-item-body>
        </nb-accordion-item>
    </nb-accordion>
</div>
<ngx-spinner
[fullScreen]="false"
type="ball-clip-rotate-multiple"
bdColor="none"
color="#0095ff"
size="medium"
>
</ngx-spinner>
